import { Modal } from "react-bootstrap";

export default function ProblemSetModal({show, onHide, problemId, deleteProblemFromProblemSet}) {

    const handleClick = () => {
        deleteProblemFromProblemSet(problemId);
        onHide()        
    }
    return (
        <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header >
          <Modal.Title>
            <h4 className="text-danger">Warning !</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you wants to remove problem from problem set ?
        </Modal.Body>
        <Modal.Footer>
          <button className="custom-button text-dark" onClick={onHide}>
            Close
          </button>
          <button className="custom-button text-danger" onClick={handleClick}>Remove</button>
        </Modal.Footer>
      </Modal>
    );
  }